<template>
  <CSidebar
    position="fixed"
    :unfoldable="sidebarUnfoldable"
    :visible="sidebarVisible"
    @visible-change="
      (event) =>
        $store.commit({
          type: 'updateSidebarVisible',
          value: event,
        })
    "
  >
    <div class="sidebar-body">
      <div class="sidebar-logo">
        <img
          src="@/assets/images/logo.png"
          alt="Logo Ganesha"
          class="sidebar-logo-img"
        />
      </div>
      <div class="sidebar-nav-wrap">
        <AppSidebarNav
          class="c-sidebar-nav"
          :clients="clients"
          :loading="loading"
        />
      </div>
      <div class="sidebar-return-btn">
        <a :href="GANESHA_CORE_LINK" class="sidebar-return-link">
          Volver a Ganesha-core
        </a>
      </div>
    </div>
  </CSidebar>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { AppSidebarNav } from './AppSidebarNav'
import axios from 'axios'
import routesApi from '@/ConstantesApp/constantesRoutes.js'

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNav,
  },
  setup() {
    const GANESHA_CORE_LINK = process.env.VUE_APP_GANESHA_CORE_URL
    const store = useStore()
    const clients = ref([])
    const loading = ref(true)
    const fetchClients = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search)
        const token = urlParams.get('token') || localStorage.getItem('token')

        if (!token) {
          loading.value = false
          return
        }
        const response = await axios.post(
          process.env.VUE_APP_ROOT_API + routesApi.user,
          {
            api_token: token,
          },
        )

        if (response.data.res) {
          localStorage.setItem('token', token)
          localStorage.setItem('user', JSON.stringify(response.data.user))
          clients.value = response.data.clientes
        }
      } catch (error) {
        console.error('Error al obtener clientes:', error)
      }
    }

    const fetchDeclarations = async (clientId) => {
      try {
        const response = await axios.post(
          process.env.VUE_APP_ROOT_API + routesApi.showDatosGeneralesAll,
          {
            id: clientId,
            api_token: localStorage.getItem('token'),
          },
        )
        return response.data.res ? response.data.message : []
      } catch (error) {
        console.error('Error fetching declarations:', error)
        return []
      }
    }

    const fetchAnualLiquidations = async (clientId) => {
      try {
        const response = await axios.post(
          process.env.VUE_APP_ROOT_API + routesApi.showAnualLiquidations,
          {
            clientId: clientId,
            api_token: localStorage.getItem('token'),
          },
        )
        return response.data.res ? response.data.message : []
      } catch (error) {
        console.error('Error fetching annual liquidations:', error)
        return []
      }
    }

    const loadClientsWithData = async () => {
      loading.value = true
      await fetchClients()
      if (!clients.value?.length) {
        loading.value = false
        return
      }

      const promises = clients.value.map(async (client) => {
        const [declarations, annualLiquidations] = await Promise.all([
          fetchDeclarations(client.id),
          fetchAnualLiquidations(client.id),
        ])
        return { ...client, declarations, annualLiquidations }
      })
      clients.value = await Promise.all(promises)
      loading.value = false
    }

    loadClientsWithData()

    return {
      sidebarUnfoldable: computed(() => store.state.sidebarUnfoldable),
      sidebarVisible: computed(() => store.state.sidebarVisible),
      clients,
      loading,
      GANESHA_CORE_LINK,
    }
  },
}
</script>
